import * as React from 'react';
import { TrashIcon } from '@heroicons/react/24/outline';
import {
  Button,
  Col,
  Container,
  Loading,
  Row,
  Spacer,
  User,
  useTheme,
} from '@nextui-org/react';
import Image from 'next/image';
import { User as GQLUser } from '@generated/type-graphql';
import { AppTitle } from '@src/layouts/app/AppTitle';
import { useSessionUser } from '@src/layouts/app/hooks/useSessionUser';
import { useUser } from '@src/layouts/app/hooks/useUser';

interface AllFriendsProps {}

/**
 * @name AllFriends
 * @description tbd...
 */
export function AllFriends(_props: AllFriendsProps) {
  // Hooks
  const { theme } = useTheme();
  const { isLoadingSessionUser, sessionUser } = useSessionUser();
  const { errorUser, isLoadingUser, user } = useUser(sessionUser?.email ?? '');

  // Setup
  const friends = user?.friends ?? [];

  // Handlers
  const onAddFriend = (user: GQLUser) => {
    console.log('onAddFriend', user);
  };

  if (isLoadingUser || errorUser) return null;
  if (typeof window !== 'undefined' && isLoadingSessionUser) return null;

  return (
    <Container xl direction="row" gap={0}>
      <Spacer />
      {/* Title */}
      <Row>
        <AppTitle color="warning">
          <Image
            src="/images/people.png"
            width={40}
            height={40}
            priority={true}
          />
          All Friends
        </AppTitle>
      </Row>
      <Spacer />

      {/* Users */}
      {isLoadingUser ? (
        <Row justify="center">
          <Loading />
        </Row>
      ) : (
        friends.map((user) => (
          <>
            <Row key={user.name} justify="space-between">
              <Col>
                <User squared src={user.image} name={user.name} />
              </Col>
              <Col span={2}>
                <Button
                  onClick={() => onAddFriend(user)}
                  css={{ padding: '$4' }}
                  auto
                  bordered
                  // eslint-disable-next-line @typescript-eslint/no-explicit-any
                  color={theme?.colors.text.value as any}
                  icon={
                    <TrashIcon
                      style={{
                        color: theme?.colors.text.value,
                        height: '24px',
                        width: '24px',
                      }}
                    />
                  }
                />
              </Col>
            </Row>
            <Spacer y={0.3} />
          </>
        ))
      )}
    </Container>
  );
}
